import React, { useEffect, useState } from "react";
import classes from "./TermsOfService.module.css";
import { ReactComponent as Cube } from "../../../assets/squares-bg 4.svg";
import { getConfigurationValue } from "../../../lib/OptionListApi";

const TermsOfService = () => {
	const [countryName, setCountryName] = useState<string | null>(null);

	useEffect(() => {
		const fetchCountryId = async () => {
			try {
				const countryId = await getConfigurationValue(2);
				const countryValue = Number(countryId);
				setCountryName(countryValue === 2 ? "Shqipërisë" : "Kosovës");
			} catch (error) {
				console.error("Failed to fetch country ID:", error);
			}
		};
		fetchCountryId();
	}, []);
	const forAlbania = countryName === "Shqipërisë";

	return (
		<div className={classes.mainContainer}>
			<div className={classes.firstContainer}>
				<div className={classes.titles}>
					<div>
						<h1 className={classes.title}>Kushtet e shërbimit</h1>
						<p>Kushtet e bashkëpunimit tonë</p>
					</div>
				</div>
				<Cube />
			</div>
			<div className={classes.secondContainer}>
				{forAlbania ? (
					<p>
						<b>Neni 1</b>
						<br /> <b>Objekti i kontratës</b>
						<br /> Objekt i kësaj kontrate është ofrimi i shërbimeve
						postare dhe transporti i dërgesave nga Kryeresi i
						Shërbimeve në tërë territorin e Republikës se Kosovës
						apo vendeve tjera sipas kërkesës dhe për llogari të
						Porositesit të Shërbimeve, në adresat e destinimit.
						<br />
						<br />
						<b>Neni 2 </b>
						<br />
						<b>Afati Kontraktues</b>
						<br />
						Kjo Kontratë për kryerjen e Shërbimeve Postare lidhet
						për një periudhë kohore prej 1 (një) viti nga data e
						nënshkrimit të saj, përkatësisht deri më _____ me
						mundësi vazhdimi edhe për 1 (një) vit tjetër, përveç
						rasteve kur paraqiten kushtet për zgjidhjen e
						parakohshme të kontratës, sipas marrëveshjes së palëve
						kontraktuese.
						<br />
						<br />
						<b>Neni 3</b>
						<br />
						<b>Përkufizime</b>
						<br /> Në këtë kontratë përveç kur kontesti e kërkon
						ndryshe termat e përdorur kanë kuptimet e dhëna si më
						poshtë:
						<br />
						<b>Ofruesi i shërbimit</b>
						postar është personi fizik ose juridik që ofron një ose
						më shumë shërbime postare.
						<br />
						<b>Dërguesi</b> është një person fizik ose juridik, që
						është përgjegjës për objektet postare të nisura prej
						tij.
						<br />
						<b>Objekt postar</b> është një objekt i adresuar, në
						formën e tij përfundimtare, që dërgohet nga ofruesi i
						shërbimit postar ku, përveç objekteve të korrespondencës
						së letrave, përfshihen dhe librat, katalogët, gazetat,
						revistat dhe pakot postare që përmbajnë mallra me ose pa
						vlerë tregtare.
						<br />
						<b>Objekt postar i regjistruar</b> është një objekt
						postar që regjistrohet nga ofruesi i shërbimit, kundrejt
						një pagese fikse, për të garantuar dorëzimin e objektit
						postar dhe dëmshpërblimin, në rast të humbjes, grabitjes
						dhe vjedhjes. Dëmshpërblimi paguhet pas kërkesës dhe kur
						provohet mosdorëzimi i objektit postar ose i
						mosshpërndarjes së tij në destinacion.
						<br />
						<b>Objekte të korrespondencës</b> është komunikimi me
						shkrim, mbi çdo lloj objekti fizik që do të transmetohet
						dhe dërgohet në adresën e treguar nga dërguesi, mbi vetë
						objektin ose në ambalazhin e tij.Librat, katalogët,
						gazetat dhe shkrimet periodike nuk do të konsiderohen si
						artikuj të korrespondencës.
						<br />
						<b>Shërbime postare</b> janë shërbimet që përfshijnë
						pranimin, përpunimin, transportin dhe shpërndarjen e
						dërgesave postare në rrjetin postar kombëtar dhe
						ndërkombëtar/ndërkufitar.
						<br />
						<b>Objekte të siguruara</b> është një objekt postar, i
						siguruar me shërbim të veçantë, deri në vlerën e
						deklaruar nga dërguesi, në rast humbjeje, vjedhjeje,
						dëmtimi. <br />
						<b>Shërbime të veçanta</b> është shërbimi i
						regjistrimit, i sigurimit dhe regjistrimit,
						lajmërimmarrjes, postës ajrore, shërbimit ekspres,
						pagesës në çastin e dorëzimit, për objektet e thyeshme
						dhe delikate, për t’iu dorëzuar vetëm të adresuarit.
						<br />
						<b>Objekt Postarpostare</b> dërgesa postare që përmban
						mall ose artikull, me ose pa vlerë komerciale. Pranimi
						është veprimi, me të cilin ofruesi i shërbimit postar
						pranon objektet postare, me qëllim shpërndarjen e tyre
						në destinacion.
						<br />
						<b>Përpunimi i objekteve postare</b> –tërësia e
						veprimeve të kryera pas pranimit të dërgesave, duke
						përfshirë kategorizimin, përzgjedhjen deri te dorëzimi i
						dërgesave postare tek personi i adresuar përmes rrjetit
						postar, duke përfshirë dorëzimin personal me konfirmim
						të pranimit.
						<br />
						<b>Shpërndarje</b> është procesi i përpunimit në qendrën
						e shpërndarjes për dorëzimin e objekteve postare në
						destinacion.
						<br />
						<b>Dorëzimi</b> është rrugëtimi i objekteve postare nga
						pika e pranimit deri te dorëzimi i tyre në adresë.
						<br /> <br />
						<b>Neni 4</b>
						<br />
						<b>Detyrimet e Palëve</b>
						<br />
						4.1 Dërguesi është përgjegjës për konfirmimin e numrit
						të dërgesave të pranuara ndaj të cilave kërkohet
						shërbimi postar nga Ofruesi i shërbimit postar dhe për
						secilin Objekt Postar dërguesi është i obliguar të
						printoje etiketën me të dhënat e objekti postar nga
						sistemi elektronik dhe të gjitha dërgesat të kenë të
						bashkangjitur etiketën në fjalë në mënyrë që Ofruesi i
						shërbimit të ketë mundësi të marrë kodin unik të saktë
						të secilës Objekt Postarpër dorëzim.
						<br />
						<br />
						<b>Neni 5</b>
						<br />
						<b>Procesi i parashikuar për tu ndjekur nga Dërguesi</b>
						<br />
						5.1 Dërguesi para dorëzimit të dërgesës postare tek
						Ofruesi i shërbimit postar detyrohet ti plotësoj të
						gjitha informacionet e sakta në lidhje me Marrësin e
						dërgesës postare ku përfshihen këto informacionet: Emri,
						Mbiemri, Adresa e plotë, Numri i Telefonit,
						Informacionet e porosisë apo dërgesës: përmasat, peshën,
						vlerën dhe përshkrimin e produktit. Në rast se adresa e
						destinimit të dërgesës postare nuk është e saktë, por
						vetëm emri i qytetit ose i lagjës, porosia do të
						procesohet 24 orë me vonesë, pasi që duhet të trajtohet
						nga suporti për marrjen e saktë të adresës.
						<br /> 5.2 Dërguesi duhet të printojë etiketën për
						secilin objekt Postar nga sistemi dhe ta bashkangjesë
						mirë në pako. Dërgesat pa etiketë nuk mund të pranohen
						nga Ofruesi i shërbimit postar , pasi vetëm kështu
						sigurohet saktësia e kodit unik të dërgesës.
						<br /> 5.3 Dërguesi nuk mund të shënojë nje pako me
						vlera zero ose vlera jo të sakta (më të vogla se ajo
						reale). Duhet të shënohet vlera reale në instruksionet
						për dorëzim, pasi që në rast të shpagimit të ndonjë
						dërgese, vlera e shpaguar do të bazohet sipas deklarimit
						në sistem të bërë nga porositësi. Ofruesi i shërbimit
						postar nuk mban përgjegjësi për vlera të tjera jashtë
						instruksioneve për dorëzim.
						<br /> 5.4 Nëse përmasat dhe pesha e dërgesës të dhënë
						nga dërguesi nuk janë të sakta, Departamenti i Njësisë
						së Kostove të Transportit do të bëjë ndryshimin e kostos
						së transportit bazuar në përmasat reale. Dërguesi mund
						ta shohë këtë ndryshim në sistemin e tij elektronik.
						<br /> 5.5 Dërguesi duhet të specifikojë nëse dërgesa
						postare mund të hapet ose jo.
						<br />
						5.6. Dërguesi obligohet që të specifikojë “Ndërrimet”
						dhe “Rinisjet” në sistem. Ndërrimi pa sistem nuk do të
						trajtohet, pasi që çdo Objekt Postarduhet të evidentohet
						në sistem me kod të veçantë.
						<br /> 5.7 Dërguesi obligohet që ndërrimet dhe tërheqjet
						e dërgesave nga klienti i tij
						{"t'i"} evidentoj në sistem.
						<br /> 5.8 Gjatë dorëzimit të porosive, personi i
						autorizuar i Ofruesit i shërbimit postar është i
						obliguar të skanojë çdo objekt Postar që pranon
						fizikisht në momentin e pranimit. Dërguesi detyrohet të
						kontrollojë të gjitha kodet në sistem pas përfundimit të
						skanimit dhe të sigurohet që të gjitha kodet janë
						skanuar dhe trajtuar në momentin e dorëzimit. Ofruesi i
						shërbimit postar i shërbimeve është përgjegjës vetëm për
						kodet e skenuara dhe të trajtuara në momentin e
						dorëzimit.
						<br /> 5.9 Dërguesi duhet të sigurojë që paketimi i
						porosisë është i përshtatshëm për transport. Nëse
						produktet që përmban dërgesa janë të ndjeshme, kjo duhet
						të specifikohet në etiketë dhe pagesa për produktet e
						ndjeshme është e diferencuar.
						<br /> 5.10 Paketimi i mallit apo i dërgesës është
						përgjegjësi ekskluzive e deguesit, apo ndërmarrjes
						bashkëpunuese, të cilët paketimin e mallit apo të
						dërgesës postare duhet ta bëjnë në atë mënyrë duke ju
						përshtatur specifikave të produktit. Dërguesi eshte
						përgjegjës për dëmet që rrjedhin si rezultat i
						mospaketimit të duhur të dërgesës së tyre. Dërguesi
						privohet nga e drejta e dëmshpërblimit për çdo dëmtim që
						ndodh gjatë transportit si rezultat i të metave në
						paketim.
						<br /> 5.11 Dërguesi në çdo rast duhet {"t'a"} shoqëroj
						mallin apo sendin me faturë tatimore. <br />
						5.12 Dërguesi duhet të sigurohet që çdo objekt Postar të
						skanohet nga ofruesi i shërbimit postar në momentin e
						pranimit. Menjëherë pas skanimit, dërguesi obligohet të
						kontrollojë në sistem për të siguruar që të gjitha kodet
						janë skanuar dhe trajtuar siç duhet.
						<br /> 5.13 Për çdo objekt postar që mbetet me status
						regjistruar osepër grumbullim, dërguesi duhet të
						ndërmarrë veprime për të siguruar skanimin dhe dorëzimin
						e saktë.
						<br /> 5.14 Dërguesi është i detyruar të verifikojë çdo
						objekt postar të refuzuar në prani të personit të
						autorizuar nga ofruesi i shërbimit postar i shërbimeve.
						Dërgesat e refuzuara, të cilat dërguesit i vlerësohen si
						të pa kompletuara duhet të kthehen.
						<br /> 5.15 Në rast të paraqitjes së ndonjë problemi të
						transportit, Dërguesi duhet të njoftoj Shërbimin e
						Klientit pranë ofruesit i shërbimit postar jo më larg se
						2-3 ditë nga dita e paraqitjes së problemit, dhe brenda
						afatit prej 14 ditëve për paraqitjen e ndonje ankese
						tjetër në mënyrë që Ofruesi i shërbimit postar të mund
						të ndërmarrë hapa lidhur me problemin e paraqitur.
						<br /> 5.16 Dërguesi duhet të sigurojë Ofruesi i
						shërbimit postar n e shërbimeve që artikujt e dërguar
						janë të paketuar në mënyrë të përshtatshme për të
						shmangur dëmtime gjatë transportit.
						<br /> 5.17. Dërguesi është përgjegjës për të siguruar
						që përmbajtja e dërgesës nuk përmban artikuj të ndaluar
						nga ligji ose rregulloret postare.
						<br /> 5.18 Dërguesi obligohet të respektojë të gjitha
						rregulloret dhe kushtet e përcaktuara nga Ofruesi i
						shërbimit postar i shërbimeve postare dhe autoritetet
						përkatëse.
						<br />
						<br />
						<b>Neni 6</b>
						<br />{" "}
						<b>
							Procesi i parashikuar për tu ndjekur nga Ofruesi i
							shërbimit postar
						</b>{" "}
						<br />
						6.1 Ofruesi i shërbimit postar detyohet të kryej për
						llogari të porositësit të Shërbimeve, shërbime Postare
						dhe Transportin e këtyre shërbimeve brenda dhe jashtë
						territorit të Republikës së Kosovës.
						<br /> 6.2 Ofruesi i shërbimit postar obligohet duke u
						bazuar në këtë marrëveshje t’i siguroj porositësit të
						shërbimeve shpejtësinë dhe cilësinë maksimale të
						mundshme gjatë kryerjes së shërbimit. Marrja dhe
						dorëzimi i sendeve do të bëhet në vendin e përzgjedhur
						nga Dërguesi me pëlqimin e tij brenda orarit 12:00-21:00
						nga dita e hënë deri në ditën e shtunë.
						<br /> 6.3 Procesi i shpërndarjes dhe marrjes në dorëzim
						të dërgesave do të kryhet brenda kohës më të shkurtër të
						mundshme nga momenti i dorëzimit të dërgesave në zyrën e
						Ofruesi i shërbimit postar t të shërbimeve.
						<br /> 6.4 Ofruesi i shërbimit postar do t’i dërgojë të
						gjitha dërgesat në përputhje me udhëzimet e dhëna nga
						Dërguesi.
						<br /> 6.5 Të gjitha objektet nga ana e derguesit të
						cilat nuk përmbajnë etiketë më të dhënat e objektet
						postare nuk mund te pranohen nga Ofruesi i shërbimit
						postar, dhe Ofruesi i shërbimit postar mban përgjegjësi
						vetëm për dërgesat qe janë të pajisura me etiketë nga
						sisitemi elektronik i porositësit.
						<br /> 6.6 Ofruesi i shërbimit postar nuk mban
						përgjegjësi për vlera të pa sakta të dërgesës të
						deklaruara nga Dërguesi jashtë instruksioneve për
						dorëzim. Duhet të shënohet vlera reale në instruksionet
						për dorëzim, pasi që në rast të shpagimit të ndonjë
						dërgese, vlera e shpaguar do të bazohet sipas deklarimit
						në sistem të bërë nga porositësi.
						<br /> 6.7 Nëse përmasat dhe pesha e dërgesës së
						porositësit nuk janë të sakta, Departamenti i Njësisë së
						Kostove të Transportit prane Ofruesi i shërbimit do të
						bëjë ndryshimin e kostos së transportit bazuar në
						përmasat reale.
						<br /> 6.8 Për dërgesat të cilat Dërguesi nuk i ka
						evidentuar në sistemin elektronik si ndërrim apo
						tërheqje të produkteve, Ofruesi i shërbimit postar nuk
						mban përgjegjësi, për arsye se nuk mund të arrihet të
						evidentohet nësë dërgesa është kthyer tek dërguesi.
						<br /> 6.9 Nëse paketimi i dërgesave nuk është i duhur
						dhe të njejtat dëmtohen gjatë transportit, Ofruesi i
						shërbimit postar nuk është përgjegjësi për dëmtimin e
						tyre dhe nuk ka obligim kompensimi për këto porosi.
						<br /> 6.10 Në rast se dërguesi pranon dobjektin postar
						te refuzuar pa bërë kontrollin e produkteve, Ofruesi i
						shërbimit postar e konsideron si të mbyllur kodin e
						fletërefuzimit në momentin kur i autorizuari i Ofruesi i
						shërbimit postar nuk gjendet në adresën e derguesit. Për
						cdo ankesë eventuale nga dërguesi për mungesë të
						produkteve nga dërgesa e refuzuar e cila nuk është
						kontrolluar nga dërguesi, Ofruesi i shërbimit postar nuk
						ka përgjegjësi.
						<br />
						6.11 Gjatë dorëzimit të objekteve postare personi i
						autorizuar i Ofruesi i shërbimit postar është i obliguar
						të skanojë çdo objekt postar që pranon fizikisht në
						momentin e pranimit.
						<br /> 6.12 Ofruesi i shërbimit postar duhet që ta
						informoj derguesin në rast të ndonjë problemi që e
						pamundëson marrjen në kohë reale të statuseve të
						dërgesave.
						<br /> 6.13 Ofruesi i shërbimit postar është i detyruar
						të ruaj sekretin e korrespodencës si dhe të kujdeset për
						trajtimin konfidencial të çdo informacioni që merr në
						lidhje me veprimtarinë e derguesit.
						<br /> 6.14 Ofruesi i shërbimit postar po ashtu
						detyrohet të respektoj imperativin për mbrojtjen e të
						dhënave të klientit konform ligjit.
						<br /> 6.15 Ofruesi i shërbimit postar do ta menaxhoje
						procesin e shpërndarjes së dërgesave në mënyrë
						elektronike përmes aplikacioneve adekuate për
						përcjelljen e dërgesave dhe në të njëjtën kohë do ti jep
						çasje të pa limituar Porositësit që ta përcjell statusin
						e secilës dërgesë.
						<br />
						<br />
						<b>Neni 7</b>
						<br />
						<b>Barazimet Financiare</b>
						<br /> 7.1 Konfirmimi i barazimeve lidhur me kryerjen e
						shërbimeve postare është i domosdoshëm nga ana e
						porositësit të shërbimeve.
						<br /> 7.2 Ofruesi i shërbimit postar i shërbimeve nuk
						do të bëjë barazimin e ardhshëm pa konfirmimin e të
						gjitha barazimeve të mëparshme në momentin e kërkesës
						nga ana e Ofruesi i shërbimit postar t të shërbimeve.
						<br />
						<br />
						<b>Neni 8</b> <br />
						<b>Mënyra e pagesës</b> <br /> 8.1 Ofruesi i shërbimit
						postar mban nga mjetet e arkëtuara prej marresit
						(klientit të ndërmarrjes bashkëpunuese) për llogari të
						derguesit pjesën e shërbimit postar sipas ofertës së
						prezantuar dhe në përputhje me listën e çmimeve që është
						aprovuar.
						<br /> 8.2 Ofruesi i shërbimit postar transferon në
						llogarinë e derguesit pjesën e mbetur të pagesës brenda
						72 orëve nga momenti i arkëtimit në rast që ka pagesë
						për dërgesat lokale brenda territorit të Republikës së
						Shqiperise. Ndërsa për dërgesat ndërkombëtare apo jashtë
						territorit të Republikës së Shqiperise që kanë pagesë
						për të paguar, afati për transferimin e mjeteve në
						llogarinë e porositësit është 10 (dhjetë) ditë.
						<br /> <br />
						<b>Neni 9</b>
						<br />
						<b>Përgjegjësitë në mes subjekteve</b>
						<br /> 9.1 Në rastin kur subjektet (ndërmarrja
						bashkëpunuese dhe klienti i ndërmarrjes) kryejnë
						shitblerje ndërmjet vete, për çdo mosmarrëveshje
						ndërmjet tyre Ofruesi i shërbimit postar nuk merr asnjë
						përgjegjësi juridiko-civile, sepse Ofruesi i shërbimit
						postar sipas kësaj marrëveshje është palë e tretë që
						ofron vetëm shërbimin e transportit tek Dërguesi. <br />
						9.2 Kur faqja apo rrjeti komunikues i derguesit ndërpren
						dhe bllokon çdo komunikim me blerësin (marresin) duke
						mos ju përgjigjur në thirrjet e tij apo të saj, në këtë
						rast blerësi apo klienti i ndërmarrjes duhet të kërkojë
						sqarim dhe përgjegjësi nga shitësi apo ndërmarrja
						bashkëpunuese për mos përgjigje ndaj thirrjes së tij.
						<br /> 9.3 Për çdo iniciativë dhe tendencë për të
						atakuar dhe sulmuar stafin dhe punonjësit e Ofruesi i
						shërbimit postar për mos komunikim ndërmjet palëve të
						sipër përmendur, Ofruesi i shërbimit nuk do të
						përfshihet në raportet ndërmjet tyre, por do të marrë
						veprime racionale duke ja kthyer mjetet (paratë)
						blerësit, rrjedhimisht ndërmarrja bashkëpunuese-
						Dërguesi, apo faqja e saj do ta bëjë shpagimin për dëmin
						e shkaktuar ndaj Ofruesi i shërbimit postar.
						<br />
						<br />
						<b>Neni 10</b>
						<br />
						<b>Përgjegjësia për kompensimin e dëmit</b>
						<br /> 10.1 Ofruesi i shërbimit postar është përgjegjës
						për dëmet e shkaktuara gjatë transportimit të objekteve
						postare të regjistruara, të siguruara dhe të pakove
						postare, duke përfshirë:
						<br /> • Humbjen, dëmtimin apo vjedhjen e dërgesës;
						<br /> • Kalimin e afatit të transportit dhe
						shpërndarjes së dërgesave;
						<br /> • Shërbimet postare të pakryera ose të kryera në
						mënyrë jo të plotë dhe të pasaktë.
						<br /> 10.2 Pagesa për humbjen e objektit postar bëhet
						në bazë të çmimit të furnizimit të produktit.
						<br /> 10.3 Ofruesi i shërbimit postar nuk është
						përgjegjës për dëmet e shkaktuara në rast kur:
						<br /> • Transporti i objekteve postare është kryer në
						përputhje me kushtet e përcaktuara;
						<br /> • Dëmtimi ka ndodhur për shkak të forcës madhore
						(vis major);
						<br /> • Dëmtimi është shkaktuar nga fajësia ose
						neglizhenca e dërguesit ose nga natyra e përmbajtjes së
						dërgesës postare;
						<br /> • Dëmtimi është shkaktuar për shkak të dorëzimit
						të objektit postar organeve shtetërore kompetente,
						autoriteteve publike ose ofruesve të shërbimeve publike,
						siç është përcaktuar në ligj;
						<br /> • Ne rast kur dërguesi ka falsifikuar përmbajtjen
						e dërgesës postare, duke e deklaruar për një vlerë që
						tejkalon vlerën aktuale të përmbajtjes;
						<br /> • Dërguesi nuk ka paraqitur ankesë brenda afatit
						të caktuar;
						<br /> • Dëmtimi ka ndodhur për shkak të veprimeve të
						ligjshme të organeve kompetente.
						<br /> 10.4 Kalkulimi i mospërmbushjes do të llogaritet
						duke u bazuar në kostot të cilat do t’i shkaktohen
						Ofruesi i shërbimit postar t si rezultat i mos
						përmbushjes së shërbimeve dhe shpenzimeve tjera.
						<br /> 10.5 Nëse palët në kontratë nuk mund të pajtohen
						mbi shumën e cila duhet të kompensohet si rezultat i
						neglizhencës dhe mos kryerjes së shërbimeve sipas kësaj
						kontrate, niveli i dëmeve të shkaktuara do të
						përcaktohet me procedura ligjore. <br />
						<br />
						<b>Neni 11</b>
						<br />
						<b>Forca Madhore</b> <br />
						11.1 Asnjë nga Palët nuk do të jetë përgjegjëse për
						dëmet që rrjedhin nga vonesat dhe/ose gabimet në ofrimin
						e Shërbimeve siç parashihet në kushtet e kësaj
						marrëveshjeje, nëse një vonesë ose gabim i tillë është
						rezultat i rrethanave që ishin jashtë kontrollit të të
						dy Palëve, duke përfshirë pa kufizim rastet e mëposhtme:
						<br />
						• kufizimet dhe masat e vendosura nga autoritetet,
						<br /> • lufta, trazirat dhe kryengritjet e tjera
						sociale,
						<br /> • tërmetet, përmbytjet ose fatkeqësitë dhe
						katastrofat e tjera natyrore,
						<br /> • arsye të tjera jashtë kontrollit të Palëve.
						<br /> 11.2 Pala që nuk ka mundur të përmbushë
						pjesërisht ose plotësisht detyrimet e parashikuara sipas
						kësaj siç parashihet në kushtet e kësaj Marrëveshjeje,
						për shkak të forcës madhore, duhet menjëherë dhe në
						asnjë rast më vonë se 2 ditë nga dita kur ka mësuar për
						një ngjarje të tillë të forcës madhore dhe kur është
						praktikisht e mundur, për shkak të forcës madhore, ta
						informojë Palën tjetër me shkrim për një ngjarje të
						tillë të forcës madhore, kohëzgjatjen e parashikuar dhe
						pasojat e mundshme të forcës madhore, dhe t’i paraqes
						asaj dëshmi për një ndodhi të tillë si dhe të bëjë
						përpjekjet e nevojshme për të zbutur pasojat e saj dhe
						të vazhdojë me zbatimin e Marrëveshjes sa më shpejt që
						të jetë e mundur pas përfundimit të forcës madhore. Pala
						e kundërt duhet të informohet për përfundimin e ngjarjes
						së forcës madhore brenda të njëjtit afat.
						<br />
						<br />
						<b>Neni 12</b> <br />
						<b>Shërbimet e ndaluara dhe përgjegjësia ndaj tyre</b>
						<br /> 12.1 Ofruesi i shërbimit postar ndalon
						rreptësishtë dhe nuk ofron shërbime të ndaluara me ligj,
						e në veçanti që përmbajnë elemente të trafikimit me
						narkotik, armë apo substanca të tjera të parapara me
						ligj përveç rasteve kur ligji e lejon shprehimisht një
						gjë të tillë.
						<br /> 12.2 Në rast se Dërguesi apo ndërmarrjet
						bashkëpunuese ofrojnë dërgesën e tyre të paketuar me
						sende të ndaluara me ligj në Republikën e Shqiperise
						duke mos e njoftuar personin e autorizuar të
						shpërndarjes apo Ofruesin i shërbimit postar mbajnë
						përgjegjësi juridike dhe penale për veprimet e tyre. Me
						rastin e konstatimit se brenda objektit postar ka ndonjë
						mall të ndaluar menjëherë do të njoftohen organet
						kompetente duke i dhënë të gjitha të dhënat për
						derguesin dhe marresin e shërbimeve postare.
						<br /> 12.3 Ofruesi i shërbimit postar ofron shërbimin e
						transportit për çdo Objekt Postartë paketuar nga
						Dërguesi rbimeve apo ndërmarrja bashkëpunuese, duke mos
						marrë asnjë lloj përgjegjësie juridike dhe penale për
						atë se çka gjendet brenda paketimit.
						<br />
						<br />
						<b>Neni 13</b>
						<br />
						<b>
							Parandalimi i Korrupsionit dhe Konfliktit te
							Interesit
						</b>
						<br /> Nëse Ofruesi i shërbimit apo Dërguesi ofrojnë apo
						japin, në emër të vetin apo të palës tjetër, çfarëdo
						benefiti të ndaluar, në mënyrë që të:
						<br /> • marrë punën apo,
						<br />
						• kryejë punë në kushte më të favorshme, apo <br />•
						neglizhojë mbikëqyrjen mbi implementimin e obligimeve
						kontraktuale, apo <br />• sigurojë çfarëdo veprimi
						tjetër apo mungesë të veprimeve, përmes së cilave Banka
						pëson dëmtime, apo të cilat iu mundësojnë përfaqësuesit
						të Bankës, palës tjetër kontraktuese apo personit të
						autorizuar që të përfitojë avantazhe të
						pajustifikueshme, Kontrata do të konsiderohet e
						pavlefshme.
						<br />
						<br />
						<b>Neni 14</b> <br />
						<b>Kontestet dhe Kompetenca Territoriale</b>
						<br />
						14.1 Nëse kontestet eventuale lidhur me këtë kontratë
						nuk do të zgjidhen me marrëveshje në mes të palëve
						kontraktuese, atëherë ato do të zgjidhen nga Gjykata.
						<br />
						14.2 Për të gjitha çështjet të cilat nuk janë paraparë
						me këtë kontratë do të vlejnë dispozitat e Ligjit për
						Marrëdhëniet e Detyrimeve të Republikës të Shqiperise si
						dhe ligjet dhe aktet tjera në fuqi.
						<br />
						<br />
						<b>Neni 15</b>
						<br />
						<b>Shkëputja e Kontratës</b>
						<br /> Secila nga palët kontraktuese mund të shkëpusë
						këtë kontratë, me njoftim paraprak me shkrim 30 ditë më
						herët, drejtuar palës tjetër kontraktuese.
						<br />
						<br />
						<b>Neni 16</b>
						<br />
						<b>Dispozitat Përfundimtare</b> <br /> 16.1 Ndryshimi i
						përfaqësuesve të palëve autorizuese për kontraktim nuk
						sjell ndryshime në kontratë.
						<br /> 16.2 Në këtë kontratë janë paraqitur të gjitha
						elementet e vlefshmërisë, pëlqimi i palëve që marrin
						përsipër detyrime, indikatorët e ligjshëm ku mbështetet
						detyrimi si dhe objekti për formën dhe lëndën e
						kontratës.
						<br /> 16.3 Kjo kontratë mbetet në zbatim efektiv deri
						në përfundim të saj apo kur të zgjidhen ligjërisht nga
						palët.
						<br /> 16.4 Kjo kontratë përpilohet në 2 (dy) ekzemplarë
						identike në gjuhën shqipe apo në gjuhën tjetër zyrtare
						të nevojshme për palët kontraktuese nga të cilat secila
						palë merr nga 1 origjinal të kësaj kontrate.
						<br /> Palët pasi që kuptuan dhe njohën përmbajtjen e
						kësaj kontrate e nënshkruajnë me vullnetin e tyre të
						plot dhe të lirë.
					</p>
				) : (
					<>
						<div>
							<p>
								<b>Neni 1</b>
							</p>
							<p>
								<b>Objekti i kontratës</b>
							</p>
							<p>
								Objekt i kësaj kontrate është ofrimi i
								shërbimeve postare dhe transporti i dërgesave
								nga Kryeresi i Shërbimeve në tërë territorin e
								Republikës se {countryName} apo vendeve tjera
								sipas kërkesës dhe për llogari të Porositesit të
								Shërbimeve, në adresat e destinimit.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 2</b>
							</p>
							<p>
								<b>Afati Kontraktues</b>
							</p>
							<p>
								Kjo Kontratë për kryerjen e Shërbimeve Postare
								lidhet për një periudhë kohore prej 1 (një) viti
								nga data e nënshkrimit të saj, përkatësisht deri
								më {forAlbania ? "_____" : "datën 02.06.2025"},
								me mundësi vazhdimi edhe për 1 (një) vit tjetër,
								përveç rasteve kur paraqiten kushtet për
								zgjidhjen e parakohshme të kontratës, sipas
								marrëveshjes së palëve kontraktuese.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 3</b>
							</p>
							<p>
								<b>Përkufizime</b>
							</p>
							<p>
								Në këtë kontratë përveç kur kontesti e kërkon
								ndryshe termat e përdorur kanë kuptimet e dhëna
								si më poshtë:
							</p>
							<p>
								<b>Dërgesë postare</b> – një dërgesë e adresuar
								në formën e saj përfundimtare që dërgohet nga
								ofruesi i shërbimit postar.
							</p>
							<p>
								<b>Dërgesë e thjeshtë postare</b> – dërgesa
								postare që me rastin e pranimit nuk lëshohet
								dëshmi mbi pranimin e saj.
							</p>
							<p>
								<b>
									{forAlbania
										? "Objekt postar i regjistruar"
										: "Dërgesa e regjistruar"}
								</b>{" "}
								– dërgesë postare që regjistrohet nga ofruesi i
								shërbimit postar kundruall një pagese fikse për
								të garantuar dorëzimin e dërgesës postare,
								sigurinë juridike dhe dëmshpërblimin në rast të
								humbjes, grabitjes apo vjedhjes.
							</p>
							<p>
								<b>Dërgesa të korrespondencës</b> – komunikimi
								me shkrim mbi çdo lloj dërgese fizike që do të
								bartët dhe dërgohet në adresën e treguar nga
								dërguesi mbi vetë dërgesën ose në ambalazhin e
								tij.
							</p>
							<p>
								<b>Shërbime postare</b> – shërbimet me pagesë që
								përfshijnë pranimin, përpunimin, transportin dhe
								shpërndarjen e dërgesave postare në rrjetin
								postar kombëtar dhe ndërkombëtare.
							</p>
							{!forAlbania && (
								<>
									<p>
										<b>Kryerësi i shërbimeve postare</b> –
										person fizik ose juridik që ofron një
										ose më shumë shërbime postare, në këtë
										rast POSTMAN SH.P.K.
									</p>
									<p>
										<b>Porositësi i shërbimeve postare</b> –
										person fizik ose juridik që përdor
										shërbime postare si dërgues apo
										porositës.
									</p>
								</>
							)}
							<p>
								<b>
									{forAlbania
										? "Objekt Postarpostare"
										: "Pako postare"}
								</b>{" "}
								– dërgesa postare që përmban mall ose artikull,
								me ose pa vlerë komerciale.
							</p>
							<p>
								<b>
									{forAlbania
										? "Objekte të siguruara"
										: "Dërgesa e siguruar"}
								</b>{" "}
								– shërbimi i sigurimit të dërgesës postare deri
								në vlerën e deklaruar nga dërguesi në rast
								humbjeje, vjedhje ose dëmtimi.
							</p>
							<p>
								<b>Shërbime të veçanta</b> – shërbimin e
								regjistrimit të dërgesës, të sigurimit të vlerës
								së dërgesës, lajmërim-marrjen, postën ajrore,
								shërbimin ekspres, pagesën në çastin e
								dorëzimit, për dërgesat e thyeshme dhe të
								ndjeshme, si dhe ato për t’iu dorëzuar vetëm të
								adresuarit.
							</p>
							<p>
								<b>Përpunimi i dërgesave</b> – tërësia e
								veprimeve të kryera pas pranimit të dërgesave,
								duke përfshirë kategorizimin, përzgjedhjen deri
								te dorëzimi i dërgesave postare tek personi i
								adresuar përmes rrjetit postar, duke përfshirë
								dorëzimin personal me konfirmim të pranimit.
							</p>
							<p>
								<b>Shpërndarja</b> – procesi nga përpunimi në
								qendrat e shpërndarjes për shpërndarje/ dorëzim
								të dërgesave postare për në adresat e tyre.
							</p>
							<p>
								<b>Pranimi</b> – veprimi me të cilin ofruesi i
								shërbimit postar pranon dërgesat postare me
								qëllim të shpërndarjes së tyre në destinacionin
								e caktuar.
							</p>
							<p>
								<b>Dorëzimi</b> –{" "}
								{forAlbania
									? "është rrugëtimi i objekteve postare nga pika e pranimit deri te dorëzimi i tyre në adresë"
									: "procesi i dorëzimit të dërgesave postare tek i adresuar ose personi i autorizuar, vendosjen e dërgesës në kuti private postare, ose dorëzimin e dërgesës në ambientet e punës së personit të adresuar."}
							</p>
						</div>

						<div>
							<p>
								<b>Neni 4</b>
							</p>
							<p>
								<b>Detyrimet e Palëve</b>
							</p>
							<p>
								4.1{" "}
								{forAlbania
									? "Dërguesi"
									: "Porositësi i Shërbimeve"}{" "}
								është përgjegjës për konfirmimin e numrit të
								dërgesave të pranuara ndaj të cilave kërkohet
								shërbimi postar nga
								{forAlbania
									? "Ofruesi i Shërbimit Postar"
									: "Kryerësi i shërbimeve"}{" "}
								dhe për secilën dërgesë Porositësi i Shërbimeve
								është i obliguar të printoj etiketën me të
								dhënat e dërgesës nga sistemi elektronik dhe të
								gjitha dërgesat të kenë të bashkangjitur
								etiketën në fjalë në mënyrë që{" "}
								{forAlbania
									? "Ofruesi i Shërbimit Postar"
									: "Kryerësi i shërbimeve"}{" "}
								të ketë mundësi të marrë kodin unik të saktë të
								secilës dërgesë për dorëzim.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 5</b>
							</p>
							<p>
								<b>
									Procesi i parashikuar për tu ndjekur nga{" "}
									{forAlbania
										? "Dërguesi"
										: "Porositësi i Shërbimeve"}
								</b>
							</p>
							<p>
								5.1
								{forAlbania
									? "Dërguesi"
									: "Porositësi i Shërbimeve"}{" "}
								para dorëzimit të dërgesës postare tek Kryerësi
								i shërbimeve detyrohet ti plotësoj të gjitha
								informacionet e sakta në lidhje me Marrësin e
								dërgesës postare ku përfshihen këto
								informacionet: Emri, Mbiemri, Adresa e plotë,
								Numri i Telefonit, Informacionet e porosisë apo
								dërgesës: përmasat, peshën, vlerën dhe
								përshkrimin e produktit. Në rast se adresa e
								destinimit të dërgesës postare nuk është e
								saktë, por vetëm emri i qytetit ose i lagjës,
								porosia do të procesohet 24 orë me vonesë, pasi
								që duhet të trajtohet nga suporti për marrjen e
								saktë të adresës.
							</p>
							<p>
								5.2 Porositësi duhet të printojë etiketën për
								secilën dërgesë postare nga sistemi dhe ta
								bashkangjesë mirë në pako. Dërgesat pa etiketë
								nuk mund të pranohen nga
								{forAlbania
									? "ofruesi i shërbimit postar"
									: "kryerësi i shërbimeve"}
								, pasi vetëm kështu sigurohet saktësia e kodit
								unik të dërgesës.
							</p>
							<p>
								5.3 Porositësi nuk mund të shënojë pako me vlera
								zero ose vlera jo të sakta (më të vogla se ajo
								reale). Duhet të shënohet vlera reale në
								instruksionet për dorëzim, pasi që në rast të
								shpagimit të ndonjë dërgese, vlera e shpaguar do
								të bazohet sipas deklarimit në sistem të bërë
								nga porositësi.{" "}
								{forAlbania
									? "Ofruesi i shërbimit postar"
									: "Kryerësi i shërbimeve"}{" "}
								nuk mban përgjegjësi për vlera të tjera jashtë
								instruksioneve për dorëzim.
							</p>
							<p>
								5.4 Nëse përmasat dhe pesha e dërgesës të dhënë
								nga porositësi nuk janë të sakta, Departamenti i
								Njësisë së Kostove të Transportit do të bëjë
								ndryshimin e kostos së transportit bazuar në
								përmasat reale. Porositësi mund ta shohë këtë
								ndryshim në sistemin e tij elektronik.
							</p>
							<p>
								5.5 Porositësi duhet të specifikojë nëse dërgesa
								postare mund të hapet ose jo.
							</p>
							<p>
								5.6. Porositësi obligohet që të specifikojë
								“Ndërrimet” dhe “Rinisjet” në sistem. Ndërrimi
								pa sistem nuk do të trajtohet, pasi që çdo
								dërgesë duhet të evidentohet në sistem me kod të
								veçantë.
							</p>
							<p>
								5.7{" "}
								{forAlbania
									? "Dërguesi"
									: "Porositësi i Shërbimeve"}{" "}
								obligohet që ndërrimet dhe tërheqjet e dërgesave
								nga klienti i tij {"t'i"} evidentoj në sistem.
							</p>
							<p>
								5.8 Gjatë dorëzimit të porosive, personi i
								autorizuar i Kryerësit është i obliguar të
								skanojë çdo dërgesë që pranon fizikisht në
								momentin e pranimit. Porositësi detyrohet të
								kontrollojë të gjitha kodet në sistem pas
								përfundimit të skanimit dhe të sigurohet që të
								gjitha kodet janë skanuar dhe trajtuar në
								momentin e dorëzimit.
								{forAlbania
									? "Ofruesi i shërbimit postar"
									: "Kryerësi i shërbimeve"}{" "}
								është përgjegjës vetëm për kodet e skenuara dhe
								të trajtuara në momentin e dorëzimit.
							</p>
							<p>
								5.9 Porositësi duhet të sigurojë që paketimi i
								porosisë është i përshtatshëm për transport.
								Nëse produktet që përmban dërgesa janë të
								ndjeshme, kjo duhet të specifikohet në etiketë
								dhe pagesa për produktet e ndjeshme është e
								diferencuar.
							</p>
							<p>
								5.10 Paketimi i mallit apo i dërgesës është
								përgjegjësi ekskluzive e porositësit apo
								ndërmarrjes bashkëpunuese, të cilët paketimin e
								mallit apo të dërgesës postare duhet ta bëjnë në
								atë mënyrë duke ju përshtatur specifikave të
								produktit. Porositësi apo ndërmarrja
								bashkëpunuese janë përgjegjës për dëmet që
								rrjedhin si rezultat i mospaketimit të duhur të
								dërgesës së tyre.
								{forAlbania
									? "Dërguesi"
									: "Porositësi i Shërbimeve"}{" "}
								privohet nga e drejta e dëmshpërblimit për çdo
								dëmtim që ndodh gjatë transportit si rezultat i
								të metave në paketim.
							</p>
							<p>
								5.11 Porositësi në çdo rast duhet {"t'a"}{" "}
								shoqëroj mallin apo sendin me faturë tatimore.
							</p>
							<p>
								5.12 Porositësi duhet të sigurohet që çdo
								dërgesë postare të skanohet nga kryerësi në
								momentin e pranimit. Menjëherë pas skanimit,
								porositësi obligohet të kontrollojë në sistem
								për të siguruar që të gjitha kodet janë skanuar
								dhe trajtuar siç duhet.
							</p>
							<p>
								5.13 Për çdo pako që mbetet me status{" "}
								{"regjistruar"} ose
								{"për grumbullim"}, porositësi duhet të
								ndërmarrë veprime për të siguruar skanimin dhe
								dorëzimin e saktë.
							</p>
							<p>
								5.14 Porositësi i shërbimeve është i detyruar të
								verifikojë çdo dërgesë të refuzuar në prani të
								personit të autorizuar nga kryerësi i
								shërbimeve. Dërgesat e refuzuara, të cilat
								porositësi i shërbimeve i vlerësohen si të pa
								kompletuara duhet të kthehen.
							</p>
							<p>
								5.15 Në rast të paraqitjes së ndonjë problemi të
								transportit, porositësi i shërbimeve duhet të
								njoftoj Shërbimin e Klientit pranë kryerësit të
								shërbimeve jo më larg se 2-3 ditë nga dita e
								paraqitjes së problemit, dhe brenda afatit prej
								14 ditëve për paraqitjen e ndonje ankese tjetër
								në mënyrë që Kryerësi të mund të ndërmarrë hapa
								lidhur me problemin e paraqitur.
							</p>
							<p>
								5.16 Porositësi duhet të sigurojë kryerësin e
								shërbimeve që artikujt e dërguar janë të
								paketuar në mënyrë të përshtatshme për të
								shmangur dëmtime gjatë transportit.
							</p>
							<p>
								5.17. Porositësi është përgjegjës për të
								siguruar që përmbajtja e dërgesës nuk përmban
								artikuj të ndaluar nga ligji ose rregulloret
								postare.
							</p>
							<p>
								5.18 Porositësi i shërbimeve obligohet të
								respektojë të gjitha rregulloret dhe kushtet e
								përcaktuara nga kryerësi i shërbimeve postare
								dhe autoritetet përkatëse.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 6</b>
							</p>
							<p>
								<b>
									Procesi i parashikuar për tu ndjekur nga
									Kryerësit të Shërbimeve
								</b>
							</p>
							<p>
								6.1 Kryeresi i sherbimeve detyohet të kryej për
								llogari të porositësit të Shërbimeve, shërbime
								Postare dhe Transportin e këtyre shërbimeve
								brenda dhe jashtë territorit të Republikës së{" "}
								{countryName}.
							</p>
							<p>
								6.2 Kryerësi i Shërbimeve obligohet duke u
								bazuar në këtë marrëveshje t’i siguroj
								porositësit të shërbimeve shpejtësinë dhe
								cilësinë maksimale të mundshme gjatë kryerjes së
								shërbimit. Marrja dhe dorëzimi i sendeve do të
								bëhet në vendin e përzgjedhur nga porositësi i
								shërbimeve me pëlqimin e tij brenda orarit
								08:00-20:00 nga dita e hënë deri në ditën e
								shtunë.
							</p>
							<p>
								6.3 Procesi i shpërndarjes dhe marrjes në
								dorëzim të dërgesave do të kryhet brenda kohës
								më të shkurtër të mundshme nga momenti i
								dorëzimit të dërgesave në zyrën e kryerësit të
								shërbimeve.
							</p>
							<p>
								6.4 Kryerësi i shërbimeve do t’i dërgojë të
								gjitha dërgesat në përputhje me udhëzimet e
								dhëna nga Porositësi i shërbimeve.
							</p>
							<p>
								6.5 Të gjitha dërgesat nga ana e porositësit të
								cilat nuk përmbajnë etiketë më të dhënat e
								dërgesave postare nuk mund te pranohen nga
								kryerësi, dhe kryerësi mban përgjegjësi vetëm
								për dërgesat qe janë të pajisura me etiketë nga
								sisitemi elektronik i porositësit.
							</p>
							<p>
								6.6 Kryerësi i shërbimeve nuk mban përgjegjësi
								për vlera të pa sakta të dërgesës të deklaruara
								nga porositësi jashtë instruksioneve për
								dorëzim. Duhet të shënohet vlera reale në
								instruksionet për dorëzim, pasi që në rast të
								shpagimit të ndonjë dërgese, vlera e shpaguar do
								të bazohet sipas deklarimit në sistem të bërë
								nga porositësi.
							</p>
							<p>
								6.7 Nëse përmasat dhe pesha e dërgesës së
								porositësit nuk janë të sakta, Departamenti i
								Njësisë së Kostove të Transportit prane
								kryerësit të shërbimeve do të bëjë ndryshimin e
								kostos së transportit bazuar në përmasat reale.
							</p>
							<p>
								6.8 Për dërgesat të cilat porositësi nuk i ka
								evidentuar në sistemin elektronik si ndërrim apo
								tërheqje të produkteve, kryerësi nuk mbanë
								përgjegjësi, për arsye se nuk mund të arrihet të
								evidentohet nësë dërgesa është kthyer tek
								porositësi i shërbimeve.
							</p>
							<p>
								6.9 Nëse paketimi i dërgesave nuk është i duhur
								dhe të njejtat dëmtohen gjatë transportit,
								Kryerësi i shërbimeve nuk është përgjegjësi për
								dëmtimin e tyre dhe nuk ka obligim kompensimi
								për këto porosi.
							</p>
							<p>
								6.10 Në rast se porositësi pranon dërgesën e
								refuzuar pa bërë kontrollin e produkteve,
								kryerësi i shërbimeve e konsideron si të mbyllur
								kodin e fletërefuzimit në momentin kur i
								autorizuari i kryerësit nuk gjendet në adresën e
								porositësit të shërbimeve. Për cdo ankesë
								eventuale nga porositësi për mungesë të
								produkteve nga dërgesa e refuzuar e cila nuk
								është kontrolluar nga porositësi, kryerësi nuk
								ka përgjegjësi.
							</p>
							<p>
								6.11 Gjatë dorëzimit të dërgesave, personi i
								autorizuar i kryerësit të shërbimeve është i
								obliguar të skanojë çdo dërgesë që pranon
								fizikisht në momentin e pranimit.
							</p>
							<p>
								6.12 Kryerësi i shërbimeve duhet që ta informoj
								Porositësin në rast të ndonjë problemi që e
								pamundëson marrjen në kohë reale të statuseve të
								dërgesave.
							</p>
							<p>
								6.13 Kryerësi i Shërbimeve është i detyruar të
								ruaj sekretin e korrespodencës si dhe të
								kujdeset për trajtimin konfidencial të çdo
								informacioni që merr në lidhje me veprimtarinë e
								porositësit të shërbimeve.
							</p>
							<p>
								6.14 Kryerësi i Shërbimeve po ashtu detyrohet të
								respektoj imperativin për mbrojtjen e të dhënave
								të klientit konform nenit 21 paragrafi 1 nën
								paragrafi 1.6 të Ligjit NR. 06/L-038, Për
								Shërbimet Postare në Republikën e {countryName}.
							</p>
							<p>
								6.15 Kryerësi i shërbimeve do ta menaxhoj
								procesin e shpërndarjes së dërgesave në mënyrë
								elektronike përmes aplikacioneve adekuate për
								përcjelljen e dërgesave dhe në të njëjtën kohë
								do ti jep çasje të pa limituar Porositësit që ta
								përcjell statusin e secilës dërgesë.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 7</b>
							</p>
							<p>
								<b>Barazimet Financiare</b>
							</p>
							<p>
								7.1 Konfirmimi i barazimeve lidhur me kryerjen e
								shërbimeve postare është i domosdoshëm nga ana e
								porositësit të shërbimeve.
							</p>
							<p>
								7.2 Kryerësi i shërbimeve nuk do të bëjë
								barazimin e ardhshëm pa konfirmimin e të gjitha
								barazimeve të mëparshme në momentin e kërkesës
								nga ana e kryerësit të shërbimeve.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 8</b>
							</p>
							<p>
								<b>Mënyra e pagesës</b>
							</p>
							<p>
								8.1 Kryerësi i Shërbimeve mban nga mjetet e
								arkëtuara prej pritësit (klientit të ndërmarrjes
								bashkëpunuese) për llogari të porositësit të
								shërbimeve pjesën e shërbimit postar sipas
								ofertës së prezantuar dhe në përputhje me listën
								e çmimeve që është aprovuar.
							</p>
							<p>
								8.2 Kryerësi i shërbimeve transferon në
								llogarinë e porositësit të shërbimeve pjesën e
								mbetur të pagesës brenda 48 orëve nga momenti i
								arkëtimit në rast që ka pagesë për dërgesat
								lokale brenda territorit të Republikës së{" "}
								{countryName}. Ndërsa për dërgesat ndërkombëtare
								apo jashtë territorit të Republikës së{" "}
								{countryName} që kanë pagesë për të paguar,
								afati për transferimin e mjeteve në llogarinë e
								porositësit është 10 (dhjetë) ditë.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 9</b>
							</p>
							<p>
								<b>Përgjegjësitë në mes subjekteve</b>
							</p>
							<p>
								9.1 Në rastin kur subjektet (ndërmarrja
								bashkëpunuese dhe klienti i ndërmarrjes) kryejnë
								shitblerje ndërmjet vete, për çdo mosmarrëveshje
								ndërmjet tyre Kryerësi i shërbimeve nuk merr
								asnjë përgjegjësi juridiko-civile, sepse
								kryerësi i shërbimeve sipas kësaj marrëveshje
								është palë e tretë që ofron vetëm shërbimin e
								transportit tek porositësi i shërbimit.
							</p>
							<p>
								9.2 Kur faqja apo rrjeti komunikues i
								ndërmarrjes bashkëpunuese–porositësit të
								shërbimeve ndërprenë dhe bllokon çdo komunikim
								me blerësin duke mos ju përgjigjur në thirrjet e
								tij apo të saj, në këtë rast blerësi apo klienti
								i ndërmarrjes duhet të kërkojë sqarim dhe
								përgjegjësi nga shitësi apo ndërmarrja
								bashkëpunuese për mos përgjigje ndaj thirrjes së
								tij.
							</p>
							<p>
								9.3 Për çdo iniciativë dhe tendencë për të
								atakuar dhe sulmuar stafin dhe punonjësit e
								Kryerësit të shërbimeve për mos komunikim
								ndërmjet palëve të sipër përmendur, Kryerësi i
								Shërbimeve nuk do të përfshihet në raportet
								ndërmjet tyre, por do të marrë veprime racionale
								duke ja kthyer mjetet (paratë) blerësit,
								rrjedhimisht ndërmarrja bashkëpunuese-porositësi
								i shërbimeve apo faqja e saj do ta bëjë
								shpagimin për dëmin e shkaktuar ndaj Kryerësit
								të Shërbimeve.
							</p>
						</div>
						<div>
							<p>
								<b>Neni 10</b>
							</p>
							<p>
								<b>Përgjegjësia për kompensimin e dëmit</b>
							</p>
							{countryName === "Shqipërisë" && (
								<div>
									<p>Sipas nenit 32</p>
									<p>
										Termat dhe kushtet e përgjithshme të
										ofrimit të shërbimeve postare, pika{" "}
										{"ë)"} procedurat për zgjidhjene e
										ankesave
									</p>
									<p>
										10.1 Qendra e Suportit do të ofrojë një
										linjë komunikimi të qartë dhe të
										dobishme për klientët tanë kudo që ata
										ndodhen. Për t`ju ofruar një shërbim
										profesional, korrekt dhe të shpejtë,
										Postman shpk ka vënë në dispozicion
										kontakte telefonikë +355 69 703 7712 /
										+355 69 704 6358 dhe adresa elektronike
										të dedikuara enkas për qendrën e
										Suportit info@postman-al.com.
									</p>
									<p>
										Jeni të mirëpritur të na kontaktoni për
										informacione, problematika, detaje për
										procesin e likudimit, informacione për
										tarifat postare dhe shprehje interesi
										për bashkëpunime, në një nga format e
										mëposhtme të kontaktit.
									</p>
									<h4>Shqyrtimi</h4>
									<p>
										Ne i japim përparësi dhe vëmendje
										maksimale çdo ankese/sugjerimi tuaj me
										anë të një procesi të thelluar shqyrtues
										dhe analizues të çdo rasti.
									</p>
									<p>
										Afati për zgjidhjen e ankesave në lidhje
										me procesin operacional të procesit të
										shpërndarjes kanë afat 3 ditor; ankesat
										në lidhje me çështje të tjera kanë afat
										deri në 10 ditë.
									</p>
									<h4>Sugjerimi</h4>
									<p>
										Çdo sugjerim nga ekipi i Suportit vjen
										pasi merren në analizë praktikat më të
										mira shqyrtuese dhe profesionale.
									</p>
									<h4>Zgjidhja</h4>
									<p>
										Zgjidhjet e ofruara nga Qendra e
										Suportit janë tërësisht transparente dhe
										në shërbim të përmirësimit të
										vazhdueshëm të çdo procesi.
									</p>
								</div>
							)}
							<p>
								{countryName === "Shqipërisë" ? (
									<span>10.2</span>
								) : (
									<span>10.1</span>
								)}{" "}
								Kryerësi i shërbimeve postare është përgjegjës
								për dëmet e shkaktuara gjatë transportimit të
								dërgesave postare të regjistruara, të siguruara
								dhe të pakove postare, duke përfshirë:
							</p>
							<ul>
								<li>
									Humbjen, dëmtimin apo vjedhjen e dërgesës;
								</li>
								<li>
									Kalimin e afatit të transportit dhe
									shpërndarjes së dërgesave;
								</li>
								<li>
									Shërbimet postare të pakryera ose të kryera
									në mënyrë jo të plotë dhe të pasaktë.
								</li>
							</ul>
							<p>
								{countryName === "Shqipërisë" ? (
									<span>10.3</span>
								) : (
									<span>10.2</span>
								)}{" "}
								Pagesa për humbjen e dërgesës bëhet në bazë të
								çmimit të furnizimit të produktit.
							</p>
							<p>
								{countryName === "Shqipërisë" ? (
									<span>10.4</span>
								) : (
									<span>10.3</span>
								)}{" "}
								Kryerësi i shërbimeve postare nuk është
								përgjegjës për dëmet e shkaktuara në rast kur:
							</p>
							<ul>
								<li>
									Transporti i dërgesave postare është kryer
									në përputhje me kushtet e përcaktuara;
								</li>
								<li>
									Dëmtimi ka ndodhur për shkak të forcës
									madhore (vis major);
								</li>
								<li>
									Dëmtimi është shkaktuar nga fajësia ose
									neglizhenca e dërguesit ose nga natyra e
									përmbajtjes së dërgesës postare;
								</li>
								<li>
									Dëmtimi është shkaktuar për shkak të
									dorëzimit të dërgesës postare organeve
									shtetërore kompetente, autoriteteve publike
									ose ofruesve të shërbimeve publike, siç
									është përcaktuar në ligj;
								</li>
								<li>
									Porositësi i shërbimeve postare kanë
									falsifikuar përmbajtjen e dërgesës postare,
									duke e deklaruar për një vlerë që tejkalon
									vlerën aktuale të përmbajtjes;
								</li>
								<li>
									Porositësi i shërbimeve postare nuk ka
									paraqitur ankesë brenda afatit të caktuar;
								</li>
								<li>
									Dëmtimi ka ndodhur për shkak të veprimeve të
									ligjshme të organeve kompetente.
								</li>
							</ul>
							<p>
								{countryName === "Shqipërisë" ? (
									<span>10.5</span>
								) : (
									<span>10.4</span>
								)}{" "}
								Kalkulimi i mos përmbushjes do të llogaritet
								duke u bazuar në kostot të cilat do t’i
								shkaktohen kryerësit si rezultat i mos
								përmbushjes së shërbimeve dhe shpenzimeve tjera.
							</p>
							<p>
								{countryName === "Shqipërisë" ? (
									<span>10.6</span>
								) : (
									<span>10.5</span>
								)}{" "}
								Nëse, palët në kontratë nuk mund të pajtohen mbi
								shumën e cila duhet të kompensohet si rezultat i
								neglizhencës dhe mos kryerjes së shërbimeve
								sipas kësaj kontrate, niveli i dëmeve të
								shkaktuara do të përcaktohet me procedura
								ligjore.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 11</b>
							</p>
							<p>
								<b>Forca Madhore</b>
							</p>
							<p>
								11.1 Asnjë nga Palët nuk do të jetë përgjegjëse
								për dëmet që rrjedhin nga vonesat dhe/ose
								gabimet në ofrimin e Shërbimeve siç parashihet
								në kushtet e kësaj marrëveshjeje, nëse një
								vonesë ose gabim i tillë është rezultat i
								rrethanave që ishin jashtë kontrollit të të dy
								Palëve, duke përfshirë pa kufizim rastet e
								mëposhtme:
							</p>
							<ul>
								<li>
									kufizimet dhe masat e vendosura nga
									autoritetet,
								</li>
								<li>
									lufta, trazirat dhe kryengritjet e tjera
									sociale,
								</li>
								<li>
									tërmetet, përmbytjet ose fatkeqësitë dhe
									katastrofat e tjera natyrore,
								</li>
								<li>
									arsye të tjera jashtë kontrollit të Palëve.
								</li>
							</ul>
							<p>
								11.2 Pala që nuk ka mundur të përmbushë
								pjesërisht ose plotësisht detyrimet e
								parashikuara sipas kësaj siç parashihet në
								kushtet e kësaj Marrëveshjeje, për shkak të
								forcës madhore, duhet menjëherë dhe në asnjë
								rast më vonë se 2 ditë nga dita kur ka mësuar
								për një ngjarje të tillë të forcës madhore dhe
								kur është praktikisht e mundur, për shkak të
								forcës madhore, ta informojë Palën tjetër me
								shkrim për një ngjarje të tillë të forcës
								madhore, kohëzgjatjen e parashikuar dhe pasojat
								e mundshme të forcës madhore, dhe t’i paraqes
								asaj dëshmi për një ndodhi të tillë si dhe të
								bëjë përpjekjet e nevojshme për të zbutur
								pasojat e saj dhe të vazhdojë me zbatimin e
								Marrëveshjes sa më shpejt që të jetë e mundur
								pas përfundimit të forcës madhore. Pala e
								kundërt duhet të informohet për përfundimin e
								ngjarjes së forcës madhore brenda të njëjtit
								afat.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 12</b>
							</p>
							<p>
								<b>
									Shërbimet e ndaluara dhe përgjegjësia ndaj
									tyre
								</b>
							</p>
							<p>
								12.1 Kryerësi i Shërbimeve ndalon rreptësishtë
								dhe nuk ofron shërbime të ndaluara me ligj, e në
								veçanti që përmbajnë elemente të trafikimit me
								narkotik, armë apo substanca të tjera të
								parapara me ligj përveç rasteve kur ligji e
								lejon shprehimisht një gjë të tillë.
							</p>
							<p>
								12.2 Në rast se porositësi i shërbimeve apo
								ndërmarrjet bashkëpunuese ofrojnë dërgesën e
								tyre të paketuar me sende të ndaluara me ligj në
								Republikën e {countryName} duke mos e njoftuar
								personin e autorizuar të shpërndarjes apo
								Kryerësin e Shërbimeve mbajnë përgjegjësi
								juridike dhe penale për veprimet e tyre. Me
								rastin e konstatimit se brenda dërgesës ka
								ndonjë mall të ndaluar menjëherë do të njoftohen
								organet kompetente duke i dhënë të gjitha të
								dhënat për porositësin dhe pritësin e shërbimeve
								postare.
							</p>
							<p>
								12.3 Kryerësi i Shërbimeve ofron shërbimin e
								transportit për çdo dërgesë të paketuar nga
								porositësi i shërbimeve apo ndërmarrja
								bashkëpunuese, duke mos marrë asnjë lloj
								përgjegjësie juridike dhe penale për atë se çka
								gjendet brenda paketimit.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 13</b>
							</p>
							<p>
								<b>
									Parandalimi i Korrupsionit dhe Konfliktit te
									Interesit
								</b>
							</p>
							<p>
								Nëse Kryerësi i Shërbimeve apo Porositësi
								ofrojnë apo japin, në emër të vetin apo të palës
								tjetër, çfarëdo benefiti të ndaluar, në mënyrë
								që të:
							</p>
							<ul>
								<li>marrë punën apo,</li>
								<li>
									kryejë punë në kushte më të favorshme, apo
								</li>
								<li>
									neglizhojë mbikëqyrjen mbi implementimin e
									obligimeve kontraktuale, apo
								</li>
								<li>
									sigurojë çfarëdo veprimi tjetër apo mungesë
									të veprimeve, përmes së cilave Banka pëson
									dëmtime, apo të cilat iu mundësojnë
									përfaqësuesit të Bankës, palës tjetër
									kontraktuese apo personit të autorizuar që
									të përfitojë avantazhe të pajustifikueshme,
								</li>
							</ul>
							<p>Kontrata do të konsiderohet e pavlefshme.</p>
						</div>

						<div>
							<p>
								<b>Neni 14</b>
							</p>
							<p>
								<b>Kontestet dhe Kompetenca Territoriale</b>
							</p>
							<p>
								14.1 Nëse kontestet eventuale lidhur me këtë
								kontratë nuk do të zgjidhen me marrëveshje në
								mes të palëve kontraktuese, atëherë ato do të
								zgjidhen nga{" "}
								{countryName === "Shqipërisë"
									? "Gjykata e Shkallës së Parë, Tiranë"
									: "Gjykata Komerciale e Republikës së Kosovës në Prishtinë"}
								.
							</p>
							<p>
								14.2 Për të gjitha çështjet të cilat nuk janë
								paraparë me këtë kontratë do të vlejnë
								dispozitat e Ligjit për Marrëdhëniet e
								Detyrimeve të Republikës të {countryName} si dhe
								ligjet dhe aktet tjera në fuqi.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 15</b>
							</p>
							<p>
								<b>Shkëputja e Kontratës</b>
							</p>
							<p>
								Secila nga palët kontraktuese mund të shkëpusë
								këtë kontratë, me njoftim paraprak me shkrim 30
								ditë më herët, drejtuar palës tjetër
								kontraktuese.
							</p>
						</div>

						<div>
							<p>
								<b>Neni 16</b>
							</p>
							<p>
								<b>Dispozitat Përfundimtare</b>
							</p>
							<p>
								16.1 Ndryshimi i përfaqësuesve të palëve
								autorizuese për kontraktim nuk sjell ndryshime
								në kontratë.
							</p>
							<p>
								16.2 Në këtë kontratë janë paraqitur të gjitha
								elementet e vlefshmërisë, pëlqimi i palëve që
								marrin përsipër detyrime, indikatorët e ligjshëm
								ku mbështetet detyrimi si dhe objekti për formën
								dhe lëndën e kontratës.
							</p>
							<p>
								16.3 Kjo kontratë mbetet në zbatim efektiv deri
								në përfundim të saj apo kur të zgjidhen
								ligjërisht nga palët.
							</p>
							<p>
								16.4 Kjo kontratë përpilohet në 2 (dy)
								ekzemplarë identike në gjuhën shqipe apo në
								gjuhën tjetër zyrtare të nevojshme për palët
								kontraktuese nga të cilat secila palë merr nga 1
								origjinal të kësaj kontrate.
							</p>

							<p>
								Palët pasi që kuptuan dhe njohën përmbajtjen e
								kësaj kontrate e nënshkruajnë me vullnetin e
								tyre të plot dhe të lirë.
							</p>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default TermsOfService;
